export default "__VITE_ASSET__DwRDEaMF__"